import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  hasTechnicalError = signal<boolean>(false);
  inlineTechnicalError = signal<boolean>(false);
}
